import { determineSeriesPrefix as $ } from "./program-helpers.js";
const A = async ({ featuredList: s, fallbackImage: d, getResource: q }) => {
  var n, m, c, g, a, p, u, I, h, x, y, F, S, _, w;
  const i = [];
  for (let e = 0; e < s.length; e++) {
    let r = "", t = "", o = "";
    if (s[e].program_class === "Episode" ? (r = `seriesPrefix = ${$(s[e].series_prefix)}`, t = "SeriesList", o = "showFeaturedImage") : s[e].program_class === "Film" && (r = `titleCode = ${s[e].title_code}`, t = "MovieList", o = "movieFeaturedImage"), r !== "") {
      const l = await await q({
        queryKey: [
          "",
          {
            resourceName: o,
            queryVars: {
              id: r
            }
          }
        ]
      }), v = ((h = (I = (u = (p = (a = (g = (c = (m = (n = l[t]) == null ? void 0 : n.items) == null ? void 0 : m[0]) == null ? void 0 : c.featuredImage) == null ? void 0 : g.image) == null ? void 0 : a.sizes) == null ? void 0 : p[0]) == null ? void 0 : u.srcSets) == null ? void 0 : I[1]) == null ? void 0 : h.src) ?? d.url, P = (F = (y = (x = l[t]) == null ? void 0 : x.items) == null ? void 0 : y[0]) != null && F.slug ? (w = (_ = (S = l[t]) == null ? void 0 : S.items) == null ? void 0 : _[0]) == null ? void 0 : w.slug : s[e].content.slug !== "" ? s[e].content.slug : "";
      i.push({
        ...s[e],
        content: {
          ...s[e].content,
          image: v,
          slug: P
        }
      });
    } else
      i.push({
        ...s[e]
      });
  }
  return i;
};
export {
  A as getFeaturedListImages
};
